import { lStorage } from "../../utils/localStorage/lStorage";
export const config = JSON.parse(
    localStorage.getItem("config/relationships") ||
        `{"maxScore":60,"people":[]}`,
);

const dayInMiliseconds = 86400000;

export const getCheckedPeople = async () => {
    return (await lStorage.get("stats/people")) ?? [];
};

export const getPeople = async () => {
    const checkedPeople = (await getCheckedPeople()) ?? [];

    const people = config.people.map((person) => {
        const suitablePersonInChecked = checkedPeople.find(
            ({ id }) => id === person.id,
        );

        if (!suitablePersonInChecked) {
            return {
                ...person,
                idleDays: 30,
                score: person.priority * 30,
            };
        }

        const lastContactMoment =
            Math.max(...suitablePersonInChecked?.contactingMoments) ??
            Date.now() - dayInMiliseconds * 10;

        const idleDays = Math.floor(
            (Date.now() - lastContactMoment) / dayInMiliseconds,
        );

        return {
            ...person,
            idleDays,
            score: person.priority * idleDays,
        };
    });

    people.sort((a, b) => b.score - a.score);

    return people;
};

export const postContactMoment = async (personId, moment = Date.now()) => {
    const checkedPeople = (await getCheckedPeople()) ?? [];

    let person = checkedPeople.find(({ id }) => id === personId);

    if (!person) {
        const configPerson = config.people.find(({ id }) => id === personId);
        person = {
            ...configPerson,
            contactingMoments: [],
        };
        checkedPeople.push(person);
    }

    person.contactingMoments.push(moment);

    lStorage.set("stats/people", checkedPeople);
};
